import apiClient from './api/client';
import { ENDPOINTS } from './api/endpoints';

export const schedulerService = {
  getStatus: (sellerId) => apiClient.get(ENDPOINTS.SCHEDULER.STATUS, {
    params: sellerId ? { sellerId } : {},
  }),
  refresh: () => apiClient.post(ENDPOINTS.SCHEDULER.REFRESH),
};
